import { memo } from 'react';

function VoidedMarker({ backgroundColor, borderColor, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
      <path
        d="M8.84962 6.54659L6.94043 8.45578L15.9419 17.4573L17.8511 15.5481L8.84962 6.54659Z"
        fill={borderColor}
      />
      <path
        d="M15.9412 6.54615L6.94125 15.5492L8.85078 17.458L17.8507 8.45501L15.9412 6.54615Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(VoidedMarker);
